<template>
  <div>
    <h3 class="componentTitle">实证信息</h3>
    <p class="tips" style="margin: 3px 0">下方信息已根据实证数据自动读取，请检查确认，若有问题可手动修改</p>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-item label="实证周期" style="display: none;"><a-input v-decorator="['days']" /></a-form-item>
      <a-form-item label="实证周期">
        <a-range-picker v-decorator="['empiricalCycle']" style="width: calc(100% - 100px)" @change="cahngeCycle" />
        <a-checkbox @change="e => changVal({e,field: 'daysVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="饲料品种">
        <a-input v-decorator="['feedVariety']" style="width: calc(100% - 100px)" placeholder="请输入饲料品种" :maxLength="10" />
        <a-checkbox @change="e => changVal({e,field: 'feedVarietyVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="实证头数">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['intoNum']" style="width: calc(100% - 50px)" placeholder="请输入实证头数" :min="1" :max="99999" />
          <span style="float: right;">头</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'intoNumVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="实证阶段">
        <a-input v-decorator="['positiveStage']" style="width: calc(100% - 100px)" placeholder="请输入实证阶段" :maxLength="10" />
        <a-checkbox @change="e => changVal({e,field: 'positiveStageVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="重量单位">
        <a-radio-group v-model="unit" @change="e => setState({unit: e.target.value})">
          <a-radio :value="0">斤</a-radio>
          <a-radio :value="1">公斤</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="初始体重">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['avgInitialWeight']" style="width: calc(100% - 50px)" placeholder="请输入初始体重" :precision="2" />
          <span style="float: right;">{{unitText}}</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'avgInitialWeightVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="结束体重">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['avgEndWeight']" style="width: calc(100% - 50px)" placeholder="请输入结束体重" :precision="2" />
          <span style="float: right;">{{unitText}}</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'avgEndWeightVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="头均总增重">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['totalWeight']" style="width: calc(100% - 50px)" placeholder="请输入头均总增重" :precision="2" />
          <span style="float: right;">{{unitText}}</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'totalWeightVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="头均耗料">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['stageFeedCostTotal']" style="width: calc(100% - 50px)" placeholder="请输入头均耗料" :precision="2" />
          <span style="float: right;">{{unitText}}</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'stageFeedCostTotalVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="平均日增重">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['avgWeightIncrement']" style="width: calc(100% - 50px)" placeholder="请输入平均日增重" :precision="2" />
          <span style="float: right;">{{unitText2}}</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'avgWeightIncrementVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="平均日采食量">
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-input-number v-decorator="['avgFeedCost']" style="width: calc(100% - 50px)" placeholder="请输入平均日采食量" :precision="2" />
          <span style="float: right;">{{unitText}}</span>
        </div>
        <a-checkbox @change="e => changVal({e,field: 'avgFeedCostVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
      <a-form-item label="料肉比">
        <a-input-number v-decorator="['weightCostRatio']" @change="changeInput" style="width: calc(100% - 100px)" placeholder="请输入料肉比" :precision="2" />
        <a-checkbox @change="e => changVal({e,field: 'weightCostRatioVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import moment from 'moment'
export default {
  components: {},
  props: ['detail'],
  data() {
    return {
      form: this.$form.createForm(this),
      unit: 0,
      stagesObj: {
        PIGLET: '教槽',
        CHILDCARE_BEFORE: '保育前期',
        CHILDCARE_AFTER: '保育后期',
        LITTLE_PIG: '仔猪',
        MEDIUM: '生长猪',
        FATTENING_PIG: '育肥猪',
        LARGE_PIG: '大猪',
      },
    }
  },
  watch: {
    detail:{
      handler(){
        this.setForm()
      },
      deep: true
    },
    unit(){
      this.setForm()
    }
  },
  computed: {
    ...mapState('news',['newsData']),
    unitText(){
      let arr = ['斤/头','公斤/头']
      return arr[this.unit]
    },
    unitText2(){
      let arr = ['斤/天','公斤/天']
      return arr[this.unit]
    },
    deleteNum(){
      let num = 1
      if(this.unit === 0){
        num = 2
      } else {
        num = 1
      }
      return num
    },
  },
  created() {},
  mounted() {
    this.setForm()
  },
  methods: {
    ...mapMutations('news',['setState','changVal']),
    changeInput(weightCostRatio){
      this.setState({weightCostRatio})
    },
    setForm(){
      let {pigLineFeedInfo,pigLineProductResult,pigLineRaiseInfos=[]} = this.detail || {}
      let {intoNum,outNum,avgInitialWeight,avgEndWeight,intoDay,outDay,} = pigLineFeedInfo || {}
      let {weightCostRatio,stageFeedCostTotal,avgFeedCost,avgWeightIncrement,stageIncrementWeightTotal} = pigLineProductResult || {}
      let days = (new Date(outDay).getTime() - new Date(intoDay).getTime()) / 1000 / 60 /60 / 24
      let stage = pigLineRaiseInfos.find(el => el.feedCost && el.feedTerminalPrice) || {}
      setTimeout(() => {
        this.form.setFieldsValue({
          empiricalCycle: [moment(intoDay),moment(outDay)],
          feedVariety: stage.productName,
          intoNum,
          positiveStage: this.stagesObj[stage.stageType],
          avgInitialWeight: (avgInitialWeight * this.deleteNum).toFixed(2),
          avgEndWeight: (avgEndWeight * this.deleteNum).toFixed(2),
          totalWeight: (stageIncrementWeightTotal * this.deleteNum / outNum).toFixed(2),
          stageFeedCostTotal: (stageFeedCostTotal * this.deleteNum / outNum).toFixed(2),
          avgWeightIncrement: (avgWeightIncrement * this.deleteNum).toFixed(2),
          avgFeedCost: (avgFeedCost * this.deleteNum).toFixed(2),
          weightCostRatio,
          days,
        })
      }, 0);
    },
    cahngeCycle(e){
      if(e.length > 0){
        let start = e[0].format('YYYY-MM-DD')
        let end = e[1].format('YYYY-MM-DD')
        let days = (new Date(end).getTime() - new Date(start).getTime()) / 1000 / 60 / 60 / 24
        this.form.setFieldsValue({days})
      }
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>